import React from "react";
import { useTranslation } from "react-i18next";
import { orderBy as test } from "natural-orderby";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { getType, getVisualizationType, subTypes, types } from "../../Editor/itemTypes";
import moment from "moment";
//import TablePagination from "@mui/material/TablePagination";
//import Typography from "@mui/material/Typography";
//import Box from "@mui/material/Box";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export const getTableAnswer = (row) => {
  switch (getVisualizationType(row.type)) {
    case types.slider:
      return `${row.primaryScore} (${row.score}%)`;
    case types.choice:
    case types.open:
      return row.score;
    default:
     /*  if (row.type === subTypes.time)
        return moment.utc(row.primaryScore * 1000).format("HH:mm"); */
      return row.scoreArr;
  }
};

/* function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
} 

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}*/

function EnhancedTableHead(props) {
  const { t } = useTranslation();
  const { order, orderBy, onRequestSort } = props;
  const headCells = [
    {
      id: "number",
      numeric: false,
      disablePadding: false,
      label: "N°",
    },
    {
      id: "label",
      numeric: false,
      disablePadding: false,
      label: t("timeline.buttons.label"),
    },
    {
      id: "question",
      numeric: false,
      disablePadding: false,
      label: t("timeline.buttons.question"),
    },
    {
      id: "score",
      numeric: false,
      disablePadding: false,
      label: t("timeline.buttons.answer"),
    },
  ];

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={`TableCell${headCell.id}`}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default function EnhancedTable(props) {
  const [order, setOrder] = React.useState("asc"); // desc / asc
  const [orderBy, setOrderBy] = React.useState("number");
  //const [page, setPage] = React.useState(0);
  const dense = React.useState(true);
  //const [rowsPerPage, setRowsPerPage] = React.useState(props.data.length);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  /*
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
   const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, props.data.length - page * rowsPerPage);
 */

  return (
    <div>
      <Paper variant="outlined">
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
            sx={{
              [`& .${tableCellClasses.root}`]: {
                borderBottom: "none",
              },
            }}
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
            />
            <TableBody>
              {test(props.data, (data) => data[orderBy], order)
                //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow hover tabIndex={-1} key={`TableRow${row.number}`}>
                      <TableCell align="left">{row.number}</TableCell>
                      <TableCell id={labelId} scope="row">
                        {row.label}
                      </TableCell>
                      <TableCell align="left">{row.question}</TableCell>
                      <TableCell align="left">
                        {getTableAnswer(row)}
                        {/*           <LightTooltip
                          placement="bottom-start"
                          title={
                            <Box style={{ padding: 8 }}>
                              <Typography variant="body2">{`${row.score}`}</Typography>
                            </Box>
                          }
                        >
                          <Typography
                            noWrap
                            variant="body2"
                            style={{ maxWidth: 300 }}
                          >
                            {row.score}
                          </Typography>
                        </LightTooltip> */}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/*               {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={12} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10]}
          component="div"
          count={props.data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        /> */}
      </Paper>
    </div>
  );
}
